import { createContext, ReactElement, ReactNode, useContext } from 'react';

type Props = { children: ReactNode; sportName: string };

const SportDataContext = createContext<string | undefined>(undefined);

export const SportDataProvider = (props: Props): ReactElement => {
  return (
    <SportDataContext.Provider value={props.sportName}>
      {props.children}
    </SportDataContext.Provider>
  );
};

export function useSportName(): string | undefined {
  const context = useContext(SportDataContext);

  return context;
}
